import Cookies from 'universal-cookie';
import { SET_LANGUAGE } from '../actions/languageAction'

const cookies = new Cookies();
const cookiesLangCode = "LanguageCode";

const initialState = {
    code: cookies.get(cookiesLangCode) || 'en-US',
  }
  
  export function languageReducer(state = initialState, action) {
    switch (action.type) {
        case SET_LANGUAGE:
            cookies.set(cookiesLangCode, action.payload, {maxAge: 60 * 60 * 24 * 365});
            return { ...state, code: action.payload }
        default:
            return state
    }
  }